const _excluded = ["className", "disabled", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// works if rendered in a component, where the IsUnderReviewContext is provided
export default function ImmutableUnderReviewFormControl(_ref) {
  let {
      className = '',
      disabled = false,
      as = 'input'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isUnderTechnicalReview = useSelector(state => state.review.isUnderTechnicalReview);
  const isDisabled = disabled || isUnderTechnicalReview;
  return /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: as,
    className: "".concat(className, " ").concat(isDisabled ? 'disabled' : '')
  }, props, {
    disabled: isDisabled
  }));
}